import React, { Component } from 'react';
import FechaHoraArchivo from './FechaHoraArchivo';
import NombreArchivo from './NombreArchivo';
import NombreFinal from './NombreFinal';

class ArchivoAsociado extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { data } = this.props;
        const { proceso, archivoAsociado } = data;

        return (
            <div>
                {proceso && proceso.TipoProceso == "O" ?
                    <div>
                        <div className="row top-separator-xs">
                            <div className="col-xs-12">
                                <div className="row bottom-separator">
                                    <div className="col-xs-12">
                                        <h2>
                                            Archivo asociado
                                        </h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <NombreArchivo data={data} archivoAsociado={archivoAsociado} setNombreArchivo={this.props.setNombreArchivo}/>
                        <FechaHoraArchivo data={data} checkArchivosAsociados={this.props.checkArchivosAsociados} setOptionFormatoArchivo={this.props.setOptionFormatoArchivo} />
                        <NombreFinal data={data} archivoAsociado={archivoAsociado}
                                                 setRadioButton={this.props.setRadioButton}
                                                 checkArchivosAsociados={this.props.checkArchivosAsociados}
                                                 setOptionFormatoArchivo={this.props.setOptionFormatoArchivo}  />
                    </div>
                    :
                    <div>
                        {null}
                    </div>
                }
            </div>
        )
    };
}

export default ArchivoAsociado;